import { render } from "./Rule.vue?vue&type=template&id=435d27a1&scoped=true&ts=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"

import "./Rule.vue?vue&type=style&index=0&id=435d27a1&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435d27a1"]])

export default __exports__